"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

// Tests for chained attributes like isRequired
var createChainableTypeChecker = function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location) {
    if (props[propName] == null) {
      var locationName = _react.ReactPropTypeLocationNames[location];

      if (isRequired) {
        return new Error("Required ".concat(locationName, " `").concat(propName, "` was not specified in ") + "`".concat(componentName, "`."));
      }

      return null;
    }

    return validate(props, propName, componentName, location);
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);
  return chainedCheckType;
}; // Progress Indicator - currentStep


var currentStepChecker = function currentStepChecker(props, propName, componentName) {
  if (typeof props.currentStep !== 'number') {
    return new Error("Invalid prop ".concat(propName, " supplied to ").concat(componentName, ". currentStep is not a number."));
  }

  if (typeof props.currentStep === 'number' && props.currentStep > props.totalSteps) {
    return new Error("Invalid prop ".concat(propName, " supplied to ").concat(componentName, ". The currentStep can not be greater than the totalSteps."));
  }

  if (typeof props.currentStep === 'number' && props.currentStep < 1) {
    return new Error("Invalid prop ".concat(propName, " supplied to ").concat(componentName, ". The currentStep can not be less than one."));
  }

  return null;
};

var currentStepCheck = createChainableTypeChecker(currentStepChecker);
var _default = currentStepCheck;
exports.default = _default;